export const participantGroups: TableModule = {
    name: "participantGroups",
    route: "spa.events.events.participantGroups",
    routeParams: [{
        param: "event",
        prop: "event_id"
    }],
    defaultOrder: {
        column: "name",
        direction: "asc"
    },
    columns: [
        {
            // The header is a swatch, see the `headerLabel_color` slot — "Farbe" does not fit one dot of width.
            name: "color",
            sortable: true,
            width: "w-[60px]",
            mobile: true
        },
        {
            name: "name",
            sortable: true,
            pageLink: true,
            mobile: true,
            truncate: false
        },
        {
            name: "description",
            breakpoint: 'md'
        },
        {
            name: "participants_count",
            width: "w-[150px]",
            mobile: true
        },
        {
            name: "created_at",
            sortable: true,
            width: "w-[150px]",
            breakpoint: 'lg'
        }
    ],
    filters: [
        {
            name: "name",
            column: "participant_groups.name",
            type: "string",
            reduced: true
        },
        {
            name: "description",
            column: "participant_groups.description",
            type: "string"
        },
        {
            name: "color",
            column: "participant_groups.color",
            type: "select",
            options: () => participantGroupColors.map((color) => ({
                value: color,
                label: useNuxtApp().$i18n.t(`participantGroups.colors.${color}`)
            }))
        }
    ],
    quickFilters: [],
    tools: [
        {
            isCreateAction: true,
            ability: ["create", "participantGroups"]
        },
        {
            name: "general.export"
        }
    ]
}
